module.exports = [{"name":"网上流向查询","url":"#","subMenu":[{"name":"销售流向查询","url":"/manage/sales"},{"name":"库存数据查询","url":"/manage/warehouse"},{"name":"采购流向查询","url":"/manage/purchase"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/menus/user_menu.json
// module id = 1734
// module chunks = 2